import React from "react";
import { useCopies } from "shared/hooks/useCopies";
import useFormApplicablePriceDetailsService from "./service";
import { FormApplicablePriceDetailsPropsType } from "./type";
import { getFormattedCurrency } from "../../../../../../shared/utils";

export default function FormApplicablePriceDetails(props: FormApplicablePriceDetailsPropsType) {
  const copies = useCopies();
  const service = useFormApplicablePriceDetailsService(props);

  return (
    <div className="tcktUpSummary">
      <div className="tcktUpSummary--title">
        <p className="tcktUpSummary--titleText">{props.regParticipantFormDetails.registrationForm.title}</p>
      </div>
      <div className="ticketUpgradeCard_footerPriceWrapper--price">
        {props.ticketUpgradeDetails.currentPrice && service.hasPriceDifference && (
          <div className="ticketUpgradeCard_footerPriceWrapper--priceAmount">
            {getFormattedCurrency(props.ticketUpgradeDetails.currentPrice)}
          </div>
        )}
        {service.applicableAmount && (
          <div className="ticketUpgradeCard_footerPriceWrapper--priceToPay">
            {service.appliedCouponCode && (
              <p
                className="buyInventory_coupon"
                dangerouslySetInnerHTML={{
                  __html: copies.get("applied.coupon.code", {
                    0: `<span class="buyInventory_coupon--value">${service.appliedCouponCode}</span>`
                  })
                }}
              />
            )}
            {getFormattedCurrency(service.applicableAmount)}
          </div>
        )}
      </div>
    </div>
  );
}
